// 회차 쓰기 — 본문만 있으면 바로 공개된다. 제목을 비우면 서버가 「N화」로 채운다.
// 글자 수는 보여주기만 하고 막지 않는다 — 첫판은 투고 제한이 꺼져 있다 (DEC-95 #3). 스위치가 켜지면 서버 거절 문구가 보인다
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router';

import { usePluginMessages } from '../../../composition/plugin-runtime';
import { usePublishEpisode, type SerialApi } from '../composition/use-serial';
import { MAX_TITLE_CHARS, charCount, codePoints } from '../domain/serial';
import { ErrorText, SignInGate } from './parts';
import { Input } from './whif/shared/ui/input';
import { WhifButton } from './whif/shared/ui/whif-button';

export function writeEpisodePage(api: SerialApi) {
  return function SerialWriteEpisodePage() {
    const t = usePluginMessages('serial');
    const navigate = useNavigate();
    const workId = useParams().id ?? '';
    const publish = usePublishEpisode(api, workId);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const chars = charCount(body);
    const ready = chars > 0 && codePoints(title.trim()) <= MAX_TITLE_CHARS;

    return (
      <SignInGate>
        <form
          className="flex flex-col gap-6 pt-6"
          onSubmit={e => {
            e.preventDefault();
            if (!ready) return;
            publish.mutate({ title, body }, { onSuccess: ep => void navigate(`/episodes/${ep.id}`) });
          }}
        >
          <h1 className="text-title-lg">{t('write.heading')}</h1>
          <Input
            label={t('write.title')}
            aria-label={t('write.title')}
            value={title}
            onChange={e => setTitle(e.target.value)}
            placeholder={t('write.titlePlaceholder')}
            maxLength={MAX_TITLE_CHARS}
          />
          <label className="flex flex-col gap-2">
            <span className="flex items-center justify-between text-sm font-semibold">
              <span>{t('write.body')}</span>
              <span aria-live="polite" className="text-label-xs-m font-normal text-text-neutral-weak">
                {t('write.chars')} {chars.toLocaleString()}
              </span>
            </span>
            {/* 본문 입력은 읽기 화면과 같은 글자 크기·줄 간격 — 쓰는 대로 읽힌다 */}
            <textarea
              value={body}
              onChange={e => setBody(e.target.value)}
              rows={20}
              className="w-full resize-y rounded-global-radius-12 border border-serial-line bg-serial-surface p-4 text-reading text-text-neutral-solid placeholder:text-text-neutral-weak focus-visible:border-line-stroke-brand-primary-solid focus-visible:outline-none"
            />
          </label>
          <ErrorText error={publish.error} />
          <WhifButton type="submit" size="xlg" isFullWidth disabled={!ready || publish.isPending}>
            {t('write.submit')}
          </WhifButton>
        </form>
      </SignInGate>
    );
  };
}
